<div class="kLinkedEntriesTable" [class.noResults]="!_entries?.length">
  <p-table
    dataKey="selectionId"
    scrollHeight="142px"
    [value]="_entries"
    [scrollable]="true"
    [customSort]="true"
    [rowTrackBy]="_rowTrackBy"
    [(selection)]="selectedEntries"
    (selectionChange)="_onSelectionChange($event)"
  >
    <ng-template pTemplate="header">
      <tr>
        <th *ngIf="allowMultiple && !disabled" style="width: 44px; padding-left: 14px">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th
          [ngStyle]="{
            'padding-left': allowMultiple && !disabled ? '0' : '14px',
            width: allowMultiple && !disabled ? '100px' : '114px'
          }"
          *ngIf="!(_kmcPermissions.FEATURE_DISABLE_KMC_LIST_THUMBNAILS | kNgIfPermitted)"
        >
          {{ 'applications.content.entryDetails.metadata.thumbnail' | translate }}
        </th>
        <th style="width: 100%">{{ 'applications.content.entryDetails.metadata.entryName' | translate }}</th>
        <th style="width: 100px" [hidden]="_documentWidth < 1320">
          {{ 'applications.content.entryDetails.metadata.entryID' | translate }}
        </th>
        <th *ngIf="!disabled" style="width: 50px"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-entry>
      <tr [pSelectableRow]="entry">
        <td *ngIf="allowMultiple && !disabled" style="width: 44px; padding-left: 14px">
          <p-tableCheckbox [value]="entry"></p-tableCheckbox>
        </td>

        <td
          [ngStyle]="{
            'padding-left': allowMultiple && !disabled ? '0' : '14px',
            width: allowMultiple && !disabled ? '100px' : '114px'
          }"
          *ngIf="!(_kmcPermissions.FEATURE_DISABLE_KMC_LIST_THUMBNAILS | kNgIfPermitted)"
        >
          <div class="kThumbnailHolder">
            <span class="kHelper"></span>
            <img [src]="entry.thumbnailUrl" onError="this.onerror=null;this.style.display='none'" />
          </div>
        </td>

        <td style="width: 100%">
          <span [kTooltip]="entry.name" class="kTableColumn">{{ entry.name }}</span>
        </td>
        <td style="width: 100px" [hidden]="_documentWidth < 1320">{{ entry.id }}</td>
        <td *ngIf="!disabled" style="width: 50px">
          <button
            pButton
            class="kButtonDefault kDeletehBtn small"
            type="button"
            icon="kIcontrash"
            [kTooltip]="'applications.content.entryDetails.metadata.removeEntry' | translate"
            (click)="deleteEntry.emit(entry)"
          ></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <div class="emptymessage">{{ _emptyMessage }}</div>
    </ng-template>
  </p-table>
</div>
